type ProjectScopedEntity = {
    projectId?: unknown;
    clientId?: unknown;
};

function normalizeScopeValue(value: unknown): string {
    return String(value || '').trim();
}

export function entityBelongsToProjectScope(options: {
    entity: ProjectScopedEntity;
    projectId: unknown;
    clientId?: unknown;
}): boolean {
    const projectId = normalizeScopeValue(options.projectId);
    const clientId = normalizeScopeValue(options.clientId);
    const entityClientId = normalizeScopeValue(options.entity.clientId);

    return Boolean(projectId)
        && normalizeScopeValue(options.entity.projectId) === projectId
        && (!clientId || !entityClientId || entityClientId === clientId);
}

export function filterEntitiesForProjectScope<T extends ProjectScopedEntity>(
    entities: T[],
    projectId: unknown,
    clientId?: unknown,
): T[] {
    return entities.filter((entity) => entityBelongsToProjectScope({ entity, projectId, clientId }));
}
